// Function to extract the last number of segments from a pathname
export function extractLastSegmentsFromPath(pathname: string, numberOfSegments: number) {
  const parts = pathname.split('/');
  const lastSegments = parts.slice(-numberOfSegments);
  return lastSegments.join('/');
}
